export const GET_ALL_GALLERY = "GET_ALL_GALLERY";
export const GET_ALL_GALLERY_SUCCESS = "GET_ALL_GALLERY_SUCCESS";
export const GET_ALL_UNSPLASH_ITEMS = "GET_ALL_UNSPLASH_ITEMS";
export const GET_ALL_GALLERY_CATEGORY = "GET_ALL_GALLERY_CATEGORY";
export const GALLERY_CATEGORY_ADD_ITEM = "GALLERY_CATEGORY_ADD_ITEM";
export const GALLERY_CATEGORY_DELETE = "GALLERY_CATEGORY_DELETE";
export const GALLERY_CATEGORY_UPDATE = "GALLERY_CATEGORY_UPDATE";
export const GET_ALL_GALLERY_FAILED = "GET_ALL_GALLERY_FAILED";